import React, { useEffect, useState } from "react";
import { loadGoogleAnalytics } from "../analytics";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem("cookie-consent");
    if (choice === "accepted") {
      loadGoogleAnalytics();
    } else if (!choice) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    loadGoogleAnalytics();
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem("cookie-consent", "refused");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] bg-[#111111] text-white/90 border-t border-white/10">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-4 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-[13px] leading-relaxed text-center md:text-left">
          Ce site utilise des cookies de mesure d'audience (Google
          Analytics) pour comprendre comment il est visité. Vous pouvez
          accepter ou refuser.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={refuse}
            className="text-[12px] uppercase tracking-widest px-4 py-2 border border-white/30 rounded-full hover:bg-white/10 transition-colors"
          >
            Refuser
          </button>
          <button
            onClick={accept}
            className="text-[12px] uppercase tracking-widest px-5 py-2 bg-[#9F8B76] text-white rounded-full hover:bg-[#8a7862] transition-colors"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
